// Protection of selling personal information under California or Nevada law
export const CCPA_STATE_COOKIE_NAME = 'dnsmpi';

export const DESKTOP_BREAKPOINT = 768;
export const CHANGE_STYLE_EVENT = 'CHANGE_STYLE';

export const MESO_AD_EVENTS = {
    PASS: 'AD-LOAD-PASS',
    FAIL: 'AD-LOAD-FAIL',
    EMPTY: 'AD-LOAD-EMPTY',
};

export const MESO_SLOT_STATUSES = {
    LOADING: 'loading',
    FAILED: 'failed',
    LOADED: 'loaded',
    RENDERING_FAILURE: 'RENDERING-FAILURE'
};
